/**
 * Crea una cadena en binario rellenando hasta un número de bits.
 * @param binaryString Cadena a rellenar.
 * @param numBits Número todal de bits de la cadena final
 */
export function fillZeroL(binaryString:string, numBits:number) : string
{
    const numZerosToAdd:number = numBits - binaryString.length;
    // let str:string = '';
    // for (let zeroInd:number = 0; zeroInd < numZerosToAdd; zeroInd++) {
    //     str += '0';
    // }
    // str += binaryString;
    // return str;
    return numZerosToAdd>0?padL(binaryString, numZerosToAdd):binaryString;
}

/**
 * Añade ceros por la izquierda a una cadena binaria.
 * @param binaryString Cadena binaria.
 * @param numBits Número de bits (0) a añadir por la izquierda.
 */
export function padL(binaryString:string, numBits:number) : string
{
    // let str:string = '';
    // for (let zeroInd:number = 0; zeroInd < numBits; zeroInd++) {
    //     str += '0';
    // }
    // str += binaryString;
    // return str;
    return `${"0".repeat(numBits)}${binaryString}`;
}

/**
 * Añade ceros por la derecha a una cadena binaria.
 * @param binaryString Cadena binaria.
 * @param numBits Número de bits (0) a añadir por la derecha.
 */
export function padR(binaryString:string, numBits:number) : string
{
    // let str:string = binaryString;
    // for (let zeroInd:number = 0; zeroInd < numBits; zeroInd++) {
    //     str += '0';
    // }
    // return str;
    return `${binaryString}${"0".repeat(numBits)}`;
}

/**
 * Codifica una cadena en base64 en bigEndian.
 * @param binaryString
 */
export function encodeBase64BigEndian(binaryString:string) : string
{
    // Pad length to multiple of 8
    const paddedBinaryValue = padR(binaryString, 7 - (binaryString.length + 7) % 8);

    let bytes = '';
    for (let i = 0; i < paddedBinaryValue.length; i += 8) {
        bytes += String.fromCharCode(parseInt(paddedBinaryValue.substr(i, 8), 2));
    }
    return btoa(bytes)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}

export function decodeBase64BigEndian(encodedString:string) : string
{
    const unsafe = encodedString
        .replace(/-/g, '+')
        .replace(/_/g, '/') + '=='.substring(0, (3 * encodedString.length) % 4);
    const bytes = atob(unsafe);

    let inputBits = '';
    for (let i = 0; i < bytes.length; i++) {
        const bitString = bytes.charCodeAt(i).toString(2);
        inputBits += padL(bitString, 8 - bitString.length);
    }

    return inputBits;
}